import React, { useEffect, useRef } from 'react';

import { ensureTrustpilotBootstrap } from './ensureTrustpilotBootstrap';

const BUSINESS_UNIT_ID = '60c847b7f033d300019ff3a1';
const TEMPLATE_ID = '54ad5defc6454f065c28af8b';

export type SliderVariant =
  | 'default'
  | 'overallExperience'
  | 'chinese'
  | 'english'
  | 'math';

/**
 * 不同场景在 Trustpilot 后台单独生成 Get code：
 * - chinese / english / math：学科页口碑区移动端（按学科标签筛选）
 * - overallExperience：用户之声「分享故事」移动端（按整体体验标签筛选）
 * - default：兜底（无标签筛选）
 */
const VARIANT_CONFIG: Record<SliderVariant, { token: string; tags?: string }> =
  {
    default: {
      token: 'fc710c85-39cf-47cb-89fb-a3e256437b1a',
    },
    overallExperience: {
      token: '501eabaa-401c-4a01-98f7-ed0fb066edf1',
      tags: 'overallexperience',
    },
    chinese: {
      token: '229fdcc1-ec02-48bf-abec-6bd3b89a33c8',
      tags: 'Chineselesson',
    },
    english: {
      token: '0d546fa6-348c-4403-b8af-02c288ffec5b',
      tags: 'ELA',
    },
    math: {
      token: '7be2e92c-c984-47ac-8838-f34521e7e7b6',
      tags: 'Math',
    },
  };

/**
 * Trustpilot 官方 TrustBox：Slider（移动端评价滑动）
 * bootstrap 由组件内部加载，页面无需再写 script
 */
const TrustpilotSlider: React.FC<{
  variant?: SliderVariant;
  className?: string;
}> = ({ variant = 'default', className }) => {
  const ref = useRef<HTMLDivElement>(null);
  const { token, tags } = VARIANT_CONFIG[variant];

  useEffect(() => {
    let cancelled = false;

    ensureTrustpilotBootstrap()
      .then(() => {
        if (!cancelled && ref.current && window.Trustpilot) {
          window.Trustpilot.loadFromElement(ref.current, true);
        }
      })
      .catch(() => {
        // bootstrap 加载失败时保留占位链接，不阻断页面
      });

    return () => {
      cancelled = true;
    };
  }, [token, tags]);

  return (
    <div className={className}>
      <div
        ref={ref}
        className="trustpilot-widget"
        data-locale="en-US"
        data-template-id={TEMPLATE_ID}
        data-businessunit-id={BUSINESS_UNIT_ID}
        data-style-height="240px"
        data-style-width="100%"
        data-token={token}
        data-tags={tags}
        data-stars="5"
        data-review-languages="en"
        data-text-color="#1B1F4D">
        <a
          href="https://www.trustpilot.com/review/wukongsch.com"
          target="_blank"
          rel="noopener">
          Trustpilot
        </a>
      </div>
    </div>
  );
};

export default TrustpilotSlider;
